const zipPlus4ToZip = (zipcode) => {
  if (!zipcode) {
    return null;
  }

  return zipcode.substring(0, 5);
};
export default zipPlus4ToZip;
